<template><svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38">
  <circle cx="16" cy="16" r="16" transform="translate(3 3)" fill="none" stroke="#dedede" stroke-width="6" />
</svg>
</template>